import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import TourDetailsMain from '../Components/Tour/TourDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import Posts from '../Components/data/data-tour.json'

function TourDetails() {
    const { slug } = useParams();
    const isLegacyNumericRoute = typeof slug === 'string' && /^\d+$/.test(slug);
    const legacyTour = isLegacyNumericRoute
        ? Posts.find((post) => post.id === parseInt(slug, 10))
        : null;

    if (legacyTour) {
        return <Navigate to={`/tour/${legacyTour.slug}`} replace />;
    }

    const selectedTour = slug ? Posts.find((post) => post.slug === slug) : null;
    const breadcrumbTitle = selectedTour ? selectedTour.title : 'Tour Details';

    return (
        <>
            <HeaderOne />
            <Breadcrumb
                title={breadcrumbTitle}
            />
            <TourDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default TourDetails
